import React from 'react';
import { Autocomplete, FormControlLabel, Switch, TextField } from '@mui/material';
import { useGetList } from 'react-admin';
import { QuickCreateDialog } from '../components/QuickCreateDialog.tsx';

type GroupDraft = {
  name: string;
  parentId?: number;
  isPond: boolean;
};

type GroupOption = { id: number; name: string };

// The fields half of the group quick create. Everything else lives in
// QuickCreateDialog so the next resource only has to supply its own fields.
export const GroupQuickCreate: React.FC = () => {
  const { data: groups = [] } = useGetList<GroupOption>('groups', {
    pagination: { page: 1, perPage: 200 },
    sort: { field: 'name', order: 'ASC' },
    filter: { includeSubgroups: true }
  });

  return (
    <QuickCreateDialog<GroupDraft>
      resource="groups"
      title="New Group"
      defaults={(typedText) => ({ name: typedText, isPond: false })}
      validate={(draft) => (draft.name.trim() ? null : 'Enter a group name')}
    >
      {(draft, setDraft) => (
        <>
          <TextField
            label="Name"
            autoFocus
            fullWidth
            value={draft.name}
            onChange={(e) => setDraft({ ...draft, name: e.target.value })}
          />
          <Autocomplete
            options={groups}
            getOptionLabel={(option) => option.name}
            value={groups.find((g) => g.id === draft.parentId) ?? null}
            onChange={(_, value) =>
              setDraft({ ...draft, parentId: value?.id })
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Parent group"
                // Without this it silently becomes a top level group.
                helperText="Leave empty to create a top level group"
              />
            )}
          />
          <FormControlLabel
            control={
              <Switch
                checked={draft.isPond}
                onChange={(e) =>
                  setDraft({ ...draft, isPond: e.target.checked })
                }
              />
            }
            label="Is Pond?"
          />
        </>
      )}
    </QuickCreateDialog>
  );
};
